import React from 'react';
import inflection from 'inflection';
import _ from 'lodash';

import SelectInput from '../../../select_input';

class PlanSelector extends React.Component {

  planOption (plan) {
    return { name: inflection.titleize(plan.name), value: plan.id };
  }

  plans () {
    return _.sortBy(this.props.plans.map(this.planOption), 'name');
  }

  render () {
    // If the current type isn't plan enabled, we'll default to the available business plan
    let businessPlan = _.find(this.props.plans, {name: 'business'});
    let planOptions = this.props.types[this.props.type].plan_enabled ? this.plans() : [this.planOption(businessPlan)];
    return (
      <SelectInput name="billing_subscription[plan_id]"
                   id="plan_id"
                   options={planOptions}
                   defaultValue={this.props.plan.id}
                   label="Plan"
                   onChange={this.props.onChange}
      />
    )
  }

}

module.exports = PlanSelector;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/admin/billing_subscriptions/plan_selector.jsx